<template>
  <v-card class="mb-4 app">
    <v-container>
      <v-row class="board">
        <v-col v-if="dragname == 'Rotas'" class="mt-5">
          <v-select
            v-model="choicedGroups"
            :items="gruposDeRotas"
            multiple
            outlined
            dense
            label="Grupos de rotas"
            @change="filtrar"
          >
            <template v-slot:selection="{ item, index }" >
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ choicedGroups.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon :color="choicedGroups.length > 0 ? 'indigo darken-4' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>
        <v-col >
          <Container
            @click="handleDragStart('filtredItens', $event)"
            :get-child-payload="getChildPayload"
            :drop-placeholder="{ class: 'placeholder' }"
          >
            <v-select
              class="mt-5"
              v-model="selecinadoComboBox"
              :items="filtredItens"
              item-text="description"
              :label="dragname"
              return-object
              multiple
              outlined
              dense
              :disabled="choicedGroups.length == 0 && dragname !== 'Codecs'"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.description ? item.description : item }}</span>
                <v-chip v-if="index === 1" small>
                  <span class="caption"> (+{{ filtredItens.length - 1 }}) </span>
                </v-chip>
              </template>
            </v-select>
          </Container>
        </v-col>
        <v-col class="text-right" cols="5">
          <v-btn class="mt-5" color="bluePcm" dark @click="insere()">Selecionar</v-btn>
          <v-spacer />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-list dense color="background">
              <div>
                <v-subheader>{{ dragname.toUpperCase() }}</v-subheader>
                <v-list-item-group v-model="item">
                  <div>
                    <Container
                      :group-name="dragname"
                      @drag-start="handleDragStart('ValoresSelecionadosDrag', $event, ValoresSelecionadosDrag)"
                      @drop="handleDrop('ValoresSelecionadosDrag', $event)"
                      :get-child-payload="getChildPayload"
                      :drop-placeholder="{ class: 'placeholder' }"
                    >
                      <Draggable v-for="(valor, key) in ValoresSelecionadosDrag" :key="key">
                        <Card>
                          <v-list-item>
                            <v-list-item-content
                              >{{ key + 1 }} - {{ typeof valor === 'object' ? valor.description : valor }}
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon color="darkRed" @click="remove(key)" v-bind="attrs" v-on="on">
                                    mdi-close-circle
                                  </v-icon>
                                </template>
                                <span>Remover</span>
                              </v-tooltip>
                            </v-list-item-icon>
                          </v-list-item>
                          <v-divider class="mx-2" />
                        </Card>
                      </Draggable>
                    </Container>
                  </div>
                </v-list-item-group>
              </div>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { registerVuexModule } from '@/utils/vuexUtils'
import { Container, Draggable } from 'vue-smooth-dnd'
import Card from '@/componentes/Card'
import troncoStore from '../_store'

export default {
  name: 'DraggAndDrop',
  props: {
    dragname: String,
    valoresDisponiveisComboBox: Array,
    opcoesSelecionadas: Array,
  },
  components: { Container, Draggable, Card },

  data: () => ({
    item: -1,
    selecinadoComboBox: [],
    ValoresSelecionadosDrag: [],
    choicedGroups: [],
    filtredItens: [],
    gruposDeRotas: [],
    allRoutes: [],
  }),
  computed: {
    ...mapGetters('draggAndDropTroncoModulePABXStore', ['getGruposDeRotas']),

    todosGruposSelecionados() {
      return this.choicedGroups.length === this.gruposDeRotas.length
    },
    algunsGruposSelecionados() {
      return this.choicedGroups.length > 0 && !this.todosGruposSelecionados
    },
    icon() {
      if (this.todosGruposSelecionados) return 'mdi-close-box'
      if (this.algunsGruposSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  async created() {
     registerVuexModule(this.$store, 'draggAndDropTroncoModulePABXStore', troncoStore)

     await this.listarGruposDeRotas()

     this.gruposDeRotas = this.getGruposDeRotas.map(grupo => ({ text: grupo.description, value: grupo._id }))
  },
  methods: {
    ...mapActions('draggAndDropTroncoModulePABXStore', ['listarGruposDeRotas']),

    handleDragStart(lane, dragResult, value) {
      const { payload, isSource } = dragResult
      if (isSource) {
        this.draggingCard = {
          lane,
          index: payload.index,
          cardData: {
            value: value[payload.index],
          },
        }
      }
    },
    handleDrop(lane, dropResult) {
      const { removedIndex, addedIndex } = dropResult
      if (lane === this.draggingCard.lane && removedIndex === addedIndex) {
        return
      }

      if (removedIndex !== null) {
        this.ValoresSelecionadosDrag.splice(removedIndex, 1)
      }

      if (addedIndex !== null) {
        this.ValoresSelecionadosDrag.splice(addedIndex, 0, this.draggingCard.cardData.value)
      }
    },
    insere() {
      this.selecinadoComboBox.forEach(valueSelecionado => {
        this.ValoresSelecionadosDrag.push(valueSelecionado)

        this.valoresDisponiveisComboBox.forEach((ValueDisponivel, index) => {
          if (ValueDisponivel === this.valoresDisponiveisComboBox.find(element => element === valueSelecionado)) {
            this.valoresDisponiveisComboBox.splice(index, 1)
          }
        })
      })
      this.selecinadoComboBox = []
    },
    remove(key) {
      this.valoresDisponiveisComboBox.push(this.ValoresSelecionadosDrag[key])
      this.ValoresSelecionadosDrag.splice(key, 1)
    },
    getChildPayload(index) {
      return {
        index,
      }
    },
     toggle() {
      this.$nextTick(() => {
        if (this.todosGruposSelecionados) {
          this.choicedGroups.splice(0)
        } else {
          this.choicedGroups.splice(0)
          this.choicedGroups = this.gruposDeRotas.map(grupo => grupo.value)
        }
        this.filtrar()
      })
    },

    filtrar() {
      this.filtredItens = []
      this.allRoutes.forEach(rota => {
        if(this.choicedGroups.includes(rota.group)) {
          this.filtredItens.push(rota)
        }
      })

    }
  },
  watch: {
    ValoresSelecionadosDrag(dragnovo) {
      this.$emit('dragUpdate', dragnovo)
    },
    opcoesSelecionadas(novo) {
      let array = []
      novo.forEach(opcao => {
        if (typeof opcao === 'object') {
          array.push(Object.assign({}, opcao))
        } else {
          array.push(opcao)
        }
      })
      this.ValoresSelecionadosDrag = array

      array.forEach(valueSelecionado => {
        this.valoresDisponiveisComboBox.forEach((ValueDisponivel, index) => {
          if (typeof valueSelecionado === 'object') {
            if (ValueDisponivel._id === valueSelecionado._id) {
              this.valoresDisponiveisComboBox.splice(index, 1)
            }
          } else {
            if (valueSelecionado === ValueDisponivel) {
              this.valoresDisponiveisComboBox.splice(index, 1)
            }
          }
        })
      })
    },
     valoresDisponiveisComboBox() {
      this.dragname !== 'Codecs' ? this.allRoutes = [] : ''

      this.dragname == 'Codecs' ? this.filtredItens = [] : ''

      this.valoresDisponiveisComboBox.forEach(rota => {
        this.dragname !== 'Codecs' ? this.allRoutes.push(rota) : ''

        this.dragname == 'Codecs' ? this.filtredItens.push(rota) : ''
      });

      this.dragname !== 'Codecs' ? this.filtrar() : ''
    }
  },
}
</script>

<style scoped>
.board {
  display: flex;
  justify-content: flex-start;
}

.lane {
  min-width: 50px;
  min-height: 50px;
  margin: 0 0.8rem;
  padding: 0 0.7rem;
}

.placeholder {
  background: rgba(33, 33, 33, 0.08);
  border-radius: 0.4rem;
  transform: scaleY(0.65);
  transform-origin: 0% 0%;
}
.app {
  background-color: var(--v-background-base);
}
</style>
